export default __webpack_public_path__ + "static/media/files.fff9ee63.svg";